(function () {
  "use strict";

  // Nach erfolgreichem Test auf false stellen
  var DEBUG = false;

  var loading = false;
  var restoring = false;
  var nextUrl = null;
  var pagesLoaded = 1;
  var io = null;
  var container = null;
  var trigger = null;
  var loader = null;
  var scrollSaveTimer = null;
  var watchdogUntil = 0;

  // Bleiben ueber init() hinweg bestehen
  var frozen = false;
  var userInteracted = false;
  var maxSeenY = 0;

  // ---------- Debug ----------

  var debugBox = null;
  function dbg(msg) {
    if (!DEBUG) return;
    if (!debugBox) {
      debugBox = document.createElement("div");
      debugBox.style.cssText = "position:fixed;top:4px;left:4px;z-index:99999;background:#000;color:#0f0;font:10px monospace;padding:4px 6px;max-width:70vw;max-height:30vh;overflow:auto;opacity:.85;pointer-events:none;white-space:pre-wrap;";
      (document.body || document.documentElement).appendChild(debugBox);
    }
    debugBox.textContent += msg + "\n";
    debugBox.scrollTop = debugBox.scrollHeight;
  }

  // ---------- State ----------

  function stateKey() {
    var u = new URL(window.location.href);
    var keep = [];
    u.searchParams.forEach(function (value, name) {
      if (name === "sort_by" || name === "q" || name.indexOf("filter.") === 0) {
        keep.push(name + "=" + value);
      }
    });
    keep.sort();
    return "inf-scroll:" + u.pathname + "?" + keep.join("&");
  }

  function findAnchor() {
    if (!container) return null;
    var cards = getCardEls(container);
    for (var i = 0; i < cards.length; i++) {
      var r = cards[i].getBoundingClientRect();
      if (r.bottom > 0) {
        var key = getCardKey(cards[i]);
        if (key) return { key: key, offset: Math.round(r.top) };
      }
    }
    return null;
  }

  function saveState(force) {
    if (restoring) return;
    if (frozen && !force) return;

    // Erst speichern, wenn der Nutzer die Seite wirklich angefasst hat.
    // Verhindert, dass ein misslungener Restore y=0 festschreibt.
    if (!userInteracted) { dbg("SKIP keine interaktion"); return; }

    var y = Math.round(window.scrollY);
    if (y > maxSeenY) maxSeenY = y;

    if (!force && maxSeenY > 400 && y < 200) { dbg("SKIP y=" + y); return; }

    try {
      var anchor = findAnchor();
      if (!anchor) { dbg("SKIP kein anker"); return; }

      localStorage.setItem(stateKey(), JSON.stringify({
        pages: pagesLoaded,
        anchorKey: anchor.key,
        anchorOffset: anchor.offset,
        scrollY: y,
        ts: Date.now()
      }));
      dbg("SAVE y=" + y + " p=" + pagesLoaded + " a=" + anchor.key);
    } catch (e) {
      dbg("SAVE FEHLER: " + e.name);
    }
  }

  function readState() {
    try {
      var raw = localStorage.getItem(stateKey());
      if (!raw) { dbg("READ: kein State"); return null; }
      var s = JSON.parse(raw);
      if (!s || Date.now() - (s.ts || 0) > 30 * 60 * 1000) { dbg("READ: abgelaufen"); return null; }
      if (!s.anchorKey) { dbg("READ: kein anker"); return null; }
      dbg("READ y=" + s.scrollY + " p=" + s.pages + " a=" + s.anchorKey);
      return s;
    } catch (e) {
      dbg("READ FEHLER: " + e.name);
      return null;
    }
  }

  // ---------- URL ----------

  function currentBaseUrl() {
    var u = new URL(window.location.href);
    u.searchParams.delete("page");
    return u.toString();
  }

  function setPage(base, page) {
    var u = new URL(base, window.location.origin);
    if (page <= 1) u.searchParams.delete("page");
    else u.searchParams.set("page", String(page));
    return u.toString();
  }

  function getDocNext(doc) {
    var link = doc.querySelector('link[rel="next"]');
    if (link && link.href) return link.href;
    var a = doc.querySelector('.collection__pagination a[rel="next"], nav.pagination a[rel="next"]');
    if (a && a.href) return a.href;
    return null;
  }

  // ---------- Karten ----------

  function getCardEls(root) {
    return Array.prototype.slice.call(
      root.querySelectorAll(".product-card-wrap, [data-product-id], [data-product-handle]")
    );
  }

  function getCardKey(el) {
    if (el.dataset && el.dataset.productId) return "id:" + el.dataset.productId;
    if (el.dataset && el.dataset.productHandle) return "h:" + el.dataset.productHandle;
    var a = el.querySelector('a[href*="/products/"]');
    if (a) {
      try {
        var u = new URL(a.getAttribute("href"), window.location.origin);
        return "u:" + u.pathname.replace(/\/$/, "");
      } catch (e) {
        return "u:" + a.getAttribute("href").replace(/\/$/, "");
      }
    }
    return null;
  }

  function findCardByKey(key) {
    if (!container || !key) return null;
    var cards = getCardEls(container);
    for (var i = 0; i < cards.length; i++) {
      if (getCardKey(cards[i]) === key) return cards[i];
    }
    return null;
  }

  function dedupe(root) {
    var seen = {};
    getCardEls(root).forEach(function (el) {
      var key = getCardKey(el);
      if (!key) return;
      if (seen[key]) el.remove();
      else seen[key] = true;
    });
  }

  // ---------- Laden ----------

  function fetchPage(url) {
    return fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var incoming =
          doc.querySelector("#infinite-scroll-container") ||
          doc.querySelector(".product-list");
        return { doc: doc, incoming: incoming };
      });
  }

  function appendPage(result) {
    if (!result.incoming || !container) return false;
    var before = container.children.length;
    container.insertAdjacentHTML("beforeend", result.incoming.innerHTML);
    dedupe(container);
    return container.children.length > before;
  }

  function advanceNextUrl(doc, loadedUrl) {
    var docNext = getDocNext(doc);
    if (docNext) {
      nextUrl = docNext;
    } else {
      var u = new URL(loadedUrl, window.location.origin);
      var p = parseInt(u.searchParams.get("page") || "1", 10);
      if (isNaN(p)) p = 1;
      nextUrl = setPage(currentBaseUrl(), p + 1);
    }
  }

  function loadMore() {
    if (!nextUrl || loading || restoring || !container) return;

    loading = true;
    if (loader) loader.style.display = "block";
    if (io && trigger) io.unobserve(trigger);

    var thisUrl = nextUrl;

    fetchPage(thisUrl)
      .then(function (result) {
        if (!result.incoming) {
          nextUrl = null;
          if (io) io.disconnect();
          return;
        }

        var grew = appendPage(result);
        if (!grew) {
          nextUrl = null;
          if (io) io.disconnect();
          return;
        }

        pagesLoaded += 1;
        saveState();
        advanceNextUrl(result.doc, thisUrl);

        requestAnimationFrame(function () {
          if (!trigger || !io) return;
          var r = trigger.getBoundingClientRect();
          if (r.top - window.innerHeight < 800) {
            loading = false;
            if (loader) loader.style.display = "none";
            loadMore();
          } else {
            io.observe(trigger);
          }
        });
      })
      .catch(function (err) {
        console.error("Infinite scroll error:", err);
        if (io) io.disconnect();
      })
      .finally(function () {
        if (loader) loader.style.display = "none";
        loading = false;
      });
  }

  // ---------- Restore ----------

  function applyAnchor(saved) {
    var card = findCardByKey(saved.anchorKey);
    if (!card) return false;
    var y = Math.max(0, window.scrollY + card.getBoundingClientRect().top - (saved.anchorOffset || 0));
    if (Math.abs(window.scrollY - y) > 2) window.scrollTo(0, y);
    return true;
  }

  function startWatchdog(saved) {
    restoring = true;
    watchdogUntil = Date.now() + 2500;
    dbg("WATCHDOG start");

    function cancel() {
      watchdogUntil = 0;
      restoring = false;
      dbg("WATCHDOG abbruch");
    }
    window.addEventListener("touchstart", cancel, { passive: true, once: true });
    window.addEventListener("wheel", cancel, { passive: true, once: true });

    function tick() {
      if (!restoring) return;
      if (Date.now() > watchdogUntil) {
        restoring = false;
        maxSeenY = Math.round(window.scrollY);
        dbg("WATCHDOG ende y=" + maxSeenY);
        return;
      }
      applyAnchor(saved);
      requestAnimationFrame(tick);
    }
    requestAnimationFrame(tick);
  }

  function restorePages(saved) {
    var targetPages = Math.min(saved.pages, 30);

    if (targetPages <= pagesLoaded) {
      startWatchdog(saved);
      return;
    }

    restoring = true;
    if (loader) loader.style.display = "block";

    var urls = [];
    for (var p = pagesLoaded + 1; p <= targetPages; p++) {
      urls.push(setPage(currentBaseUrl(), p));
    }

    Promise.all(urls.map(function (url) {
      return fetchPage(url).catch(function () { return { doc: null, incoming: null }; });
    }))
      .then(function (results) {
        var lastDoc = null, lastUrl = null;

        results.forEach(function (result, i) {
          if (result.incoming) {
            appendPage(result);
            pagesLoaded += 1;
            lastDoc = result.doc;
            lastUrl = urls[i];
          }
        });

        if (lastDoc && lastUrl) advanceNextUrl(lastDoc, lastUrl);
        if (loader) loader.style.display = "none";
        dbg("PAGES: " + pagesLoaded);
        startWatchdog(saved);
      })
      .catch(function () {
        restoring = false;
        if (loader) loader.style.display = "none";
      });
  }

  // ---------- Init ----------

  function init() {
    container = document.querySelector("#infinite-scroll-container");
    trigger = document.querySelector("#infinite-scroll-trigger");
    loader = document.querySelector("#infinite-scroll-loader");

    if (io) { io.disconnect(); io = null; }
    loading = false;
    restoring = false;

    if (!container || !trigger || !loader) { dbg("INIT: container fehlt"); return; }
    dbg("INIT ok");

    document.querySelectorAll(".collection__pagination, nav.pagination").forEach(function (el) {
      el.style.display = "none";
    });

    var u = new URL(window.location.href);
    var pageParam = parseInt(u.searchParams.get("page") || "1", 10);
    pagesLoaded = isNaN(pageParam) ? 1 : pageParam;

    nextUrl = getDocNext(document) || setPage(currentBaseUrl(), pagesLoaded + 1);

    dedupe(container);

    io = new IntersectionObserver(
      function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) loadMore();
      },
      { rootMargin: "1000px", threshold: 0.01 }
    );
    io.observe(trigger);

    var saved = readState();
    if (saved) restorePages(saved);
  }

  // ---------- Events ----------

  if ("scrollRestoration" in history) {
    history.scrollRestoration = "manual";
  }

  function markInteraction() {
    if (!userInteracted) { userInteracted = true; dbg("USER aktiv"); }
  }
  window.addEventListener("touchstart", markInteraction, { passive: true });
  window.addEventListener("wheel", markInteraction, { passive: true });
  window.addEventListener("keydown", markInteraction);

  window.addEventListener("scroll", function () {
    if (scrollSaveTimer) return;
    scrollSaveTimer = setTimeout(function () {
      scrollSaveTimer = null;
      if (container) saveState();
    }, 300);
  }, { passive: true });

  document.addEventListener("click", function (e) {
    if (!container || !e.target || !e.target.closest) return;
    if (e.target.closest('a[href*="/products/"]')) {
      saveState();
      frozen = true;
      dbg("FREEZE");
    }
  }, true);

  window.addEventListener("pagehide", function () {
    if (container && !frozen) saveState();
  });

    window.addEventListener("pageshow", function (event) {
    if (!event.persisted) return;

    // Safari holt die Seite aus dem bfcache: DOM ist komplett erhalten,
    // aber wegen scrollRestoration="manual" steht der Scroll auf 0.
    dbg("BFCACHE");
    frozen = false;
    if (io && trigger) io.observe(trigger);

    var saved = readState();
    if (saved) startWatchdog(saved);
  });

  var reinitTimer = null;
  var sectionObserver = new MutationObserver(function () {
    if (frozen) return;
    var current = document.querySelector("#infinite-scroll-container");
    if (!current || current === container) return;
    clearTimeout(reinitTimer);
    reinitTimer = setTimeout(init, 100);
  });

  function start() {
    init();
    var section = document.querySelector(".shopify-section--main-collection");
    if (section) sectionObserver.observe(section, { childList: true, subtree: true });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start);
  } else {
    start();
  }
})();